export default __webpack_public_path__ + "static/media/bottlingRuns1.401b81f4.jpg";